<template>
  <div class="p-col-12">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div :class="['card', { 'p-shadow-8': !userId }]">
      <header class="jumbotron">
        <h3>
          <strong>{{ userInfoOri.username }}</strong> Perfil
          <Button
            v-if="!inEditing"
            icon="pi pi-pencil"
            class="p-button-rounded"
            @click="inEditing = true"
          />
        </h3>
      </header>
      <form
        id="ProfileForm"
        name="ProfileForm"
        class="p-col-12 p-md-12"
        @submit.prevent="submitServiceForm"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-5">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <InputText
                    id="technicianInitials"
                    name="technicianInitials"
                    v-model="userInfo.technicianInitials"
                    :disabled="true"
                  />
                  <label for="technicianInitials">Número de Colaborador</label>
                </span>
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-8">
                <span class="p-float-label">
                  <InputText
                    id="email"
                    name="email"
                    v-model="userInfo.email"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="email">Email Profissional</label>
                </span>
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <InputText
                    id="department"
                    name="department"
                    v-model="userInfo.department"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="department">Departamento</label>
                </span>
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <InputText
                    id="area"
                    name="area"
                    v-model="userInfo.area"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="area">Área</label>
                </span>
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <InputText
                    id="office"
                    name="office"
                    v-model="userInfo.office"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="office">Escritório</label>
                </span>
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <v-date-picker
                  v-model="userInfo.startDate"
                  is-required
                  :masks="{
                    input: 'DD-MM-YYYY',
                  }"
                  :disabled="!inEditing || !can('editEmployeeFile')"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        v-bind:class="[
                          { 'p-error': errors.has('startDate') },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        v-on="
                          !inEditing || !can('editEmployeeFile')
                            ? null
                            : inputEvents
                        "
                        :disabled="!inEditing || !can('editEmployeeFile')"
                        name="startDate"
                        id="startDate"
                      />
                      <label for="startDate">Data de Admissão</label>
                    </span>
                  </template>
                </v-date-picker>
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <v-date-picker
                  v-model="userInfo.exitDate"
                  is-required
                  :masks="{
                    input: 'DD-MM-YYYY',
                  }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        v-bind:class="[
                          { 'p-error': errors.has('exitDate') },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        :disabled="!inEditing || !can('editEmployeeFile')"
                        v-on="
                          !inEditing || !can('editEmployeeFile')
                            ? null
                            : inputEvents
                        "
                        id="exitDate"
                        name="exitDate"
                      />
                      <label for="exitDate">Data de Saída</label>
                    </span>
                  </template>
                </v-date-picker>
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <InputMask
                    id="vacations1StYear"
                    name="vacations1StYear"
                    mask="99"
                    v-model="userInfo.vacations1StYear"
                    v-bind:class="[
                      { 'p-error': errors.has('vacations1StYear') },
                      'form-control',
                    ]"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="vacations1StYear">Dias Férias 1ª Ano</label>
                </span>
                <small
                  v-if="errors.has('vacations1StYear')"
                  class="p-error"
                  role="alert"
                  >Férias 1ª Ano</small
                >
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-4">
                <span class="p-float-label">
                  <Dropdown
                    name="vacationsApproveTo"
                    id="vacationsApproveTo"
                    v-model="userInfo.vacationsApproveTo"
                    :options="thatApprovesList"
                    optionLabel="username"
                    optionValue="employee"
                    :filter="true"
                    v-bind:class="[
                      { 'p-error': errors.has('vacationsApproveTo') },
                      'form-control',
                    ]"
                    :disabled="!inEditing || !can('editEmployeeFile')"
                  />
                  <label for="vacationsApproveTo">Férias Aprovadas Por</label>
                </span>
                <small
                  v-if="errors.has('vacationsApproveTo')"
                  class="p-error"
                  role="alert"
                  >Quem aprova as férias do colaborador é obrigatório</small
                >
              </div>
              <div
                class="p-field p-col-12 p-md-1 p-mt-4"
                v-if="can('editEmployeeFile')"
              >
                <span
                  class="p-float-label"
                  :style="{
                    top: '-1.2rem',
                    left: '-0.5rem',
                    'font-size': '12px',
                  }"
                >
                  <label for="hasCar">Usa Carro</label>
                </span>
                <InputSwitch
                  :disabled="!inEditing || !can('editEmployeeFile')"
                  v-model="userInfo.hasCar"
                  :name="'hasCar'"
                  :id="'hasCar'"
                  :style="{ top: '4px' }"
                />
              </div>
              <div
                class="p-field p-col-12 p-md-1 p-mt-4"
                v-if="can('editEmployeeFile')"
              >
                <span
                  class="p-float-label"
                  :style="{
                    top: '-0.8rem',
                    left: '-0.5rem',
                    'font-size': '12px',
                  }"
                >
                  <label for="status">Ativo</label>
                </span>
                <InputSwitch
                  :disabled="!inEditing || !can('editEmployeeFile')"
                  v-model="userInfo.active"
                  :name="'status'"
                  :id="'status'"
                  style="'top: 4px;"
                />
              </div>
              <divider />
              <div class="p-mt-3 p-field p-col-12 p-md-12">
                <span class="p-float-label">
                  <InputText
                    name="name"
                    id="name"
                    v-bind:class="[
                      { 'p-error': errors.has('name') },
                      'form-control',
                    ]"
                    v-model="userInfo.name"
                    :disabled="
                      !inEditing ||
                      (inEditing &&
                        userInfo.userInfoOri != null &&
                        userInfo.userInfoOri != '')
                    "
                    maxlength="55"
                    v-validate="'required'"
                  />
                  <label for="name">Nome Completo</label>
                </span>
                <small v-if="errors.has('name')" class="p-error" role="alert"
                  >Nome é obrigatório</small
                >
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <v-date-picker
                  v-model="userInfo.birthDate"
                  v-validate="'required'"
                  :masks="{
                    input: 'DD-MM-YYYY',
                  }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        v-bind:class="[
                          { 'p-error': errors.has('birthDate') },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        v-on="
                          !inEditing ||
                          (inEditing &&
                            userInfoOri.birthDate &&
                            !can('editEmployeeFile'))
                            ? null
                            : inputEvents
                        "
                        :disabled="
                          !inEditing ||
                          (inEditing &&
                            userInfoOri.birthDate &&
                            !can('editEmployeeFile'))
                        "
                        v-validate="'required'"
                        name="birthDate"
                        id="birthDate"
                      />
                      <label for="birthDate">Data de Nascimento</label>
                    </span>
                  </template>
                </v-date-picker>
                <small
                  v-if="errors.has('birthDate')"
                  class="p-error"
                  role="alert"
                  >Data de Nascimento é obrigatório</small
                >
              </div>
              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <Dropdown
                    name="namaritalStatus"
                    id="namaritalStatus"
                    v-model="userInfo.namaritalStatus"
                    :options="namaritalStatusList"
                    optionLabel="status"
                    optionValue="status"
                    v-bind:class="[
                      { 'p-error': errors.has('namaritalStatus') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="namaritalStatus">Estado Civil</label>
                </span>
                <small
                  v-if="errors.has('namaritalStatus')"
                  class="p-error"
                  role="alert"
                  >Estado Civil é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-12">
                <span class="p-float-label">
                  <InputText
                    id="address"
                    name="address"
                    v-bind:class="[
                      { 'p-error': errors.has('address') },
                      'form-control',
                    ]"
                    v-model="userInfo.address"
                    :disabled="!inEditing"
                    maxlength="55"
                    v-validate="'required'"
                  />
                  <label for="address">Morada</label>
                </span>
                <small v-if="errors.has('address')" class="p-error" role="alert"
                  >Morada é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-3 p-md-3">
                <span class="p-float-label">
                  <InputMask
                    id="zipCode"
                    name="zipCode"
                    mask="9999-999"
                    v-model="userInfo.zipCode"
                    slotChar="____-___"
                    v-bind:class="[
                      { 'p-error': errors.has('zipCode') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="zipCode">Código Postal</label>
                </span>
                <small v-if="errors.has('zipCode')" class="p-error" role="alert"
                  >Código Postal é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-9 p-md-9">
                <span class="p-float-label">
                  <InputText
                    id="local"
                    name="local"
                    v-bind:class="[
                      { 'p-error': errors.has('local') },
                      'form-control',
                    ]"
                    v-model="userInfo.local"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="local">Localidade</label>
                </span>
                <small v-if="errors.has('local')" class="p-error" role="alert"
                  >Localidade é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-3">
                <span class="p-float-label">
                  <InputMask
                    name="telephone"
                    id="telephone"
                    mask="999999999"
                    v-model="userInfo.telephone"
                    v-bind:class="[
                      { 'p-error': errors.has('telephone') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="telephone">Telemóvel</label>
                </span>
                <small
                  v-if="errors.has('telephone')"
                  class="p-error"
                  role="alert"
                  >Telemóvel é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-9">
                <span class="p-float-label">
                  <InputText
                    type="email"
                    name="personalEmail"
                    id="personalEmail"
                    v-model="userInfo.personalEmail"
                    v-bind:class="[
                      { 'p-error': errors.has('personalEmail') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="personalEmail">Email</label>
                </span>
                <small
                  v-if="errors.has('personalEmail')"
                  class="p-error"
                  role="alert"
                  >Email é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <InputText
                    id="citizenCardNum"
                    name="citizenCardNum"
                    v-bind:class="[
                      { 'p-error': errors.has('citizenCardNum') },
                      'form-control',
                    ]"
                    v-model="userInfo.citizenCardNum"
                    :disabled="
                      !inEditing ||
                      (inEditing &&
                        userInfoOri.citizenCardNum != null &&
                        userInfoOri.citizenCardNum != '' &&
                        !can('editEmployeeFile'))
                    "
                    v-validate="'required'"
                  />
                  <label for="citizenCardNum">Nº do Cartão do Cidadão</label>
                </span>
                <small
                  v-if="errors.has('citizenCardNum')"
                  class="p-error"
                  role="alert"
                  >Número do Cartão do Cidadão é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <v-date-picker
                  v-model="userInfo.citizenCardDate"
                  :min-date="new Date()"
                  is-required
                  :masks="{
                    input: 'DD-MM-YYYY',
                  }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        v-bind:class="[
                          { 'p-error': errors.has('citizenCardDate') },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        v-on="!inEditing ? null : inputEvents"
                        :disabled="!inEditing"
                        name="citizenCardDate"
                        id="citizenCardDate"
                        v-validate="'required'"
                      />
                      <label for="citizenCardDate"
                        >Validade do Cartão do Cidadão</label
                      >
                    </span>
                  </template>
                </v-date-picker>
                <small
                  v-if="errors.has('citizenCardDate')"
                  class="p-error"
                  role="alert"
                  >Cartão do Cidadão Validade é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <InputText
                    id="nif"
                    name="nif"
                    mask="999999999"
                    v-model="userInfo.nif"
                    v-bind:class="[
                      { 'p-error': errors.has('nif') },
                      'form-control',
                    ]"
                    :disabled="
                      !inEditing ||
                      (inEditing && userInfoOri.nif && !can('editEmployeeFile'))
                    "
                    v-validate="'required'"
                  />
                  <label for="nif">Nº Identificação Fiscal (NIF)</label>
                </span>
                <small v-if="errors.has('nif')" class="p-error" role="alert"
                  >NIF é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <InputText
                    id="niss"
                    name="niss"
                    mask="99999999999"
                    v-model="userInfo.niss"
                    v-bind:class="[
                      { 'p-error': errors.has('niss') },
                      'form-control',
                    ]"
                    :disabled="
                      !inEditing ||
                      (inEditing &&
                        userInfoOri.niss &&
                        !can('editEmployeeFile'))
                    "
                    v-validate="'required'"
                  />
                  <label for="niss">Nº Segurança Social (NISS)</label>
                </span>
                <small v-if="errors.has('niss')" class="p-error" role="alert"
                  >NISS é obrigatório</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <InputMask
                    id="holders"
                    name="holders"
                    mask="9"
                    v-model="userInfo.holders"
                    v-bind:class="[
                      { 'p-error': errors.has('holders') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="holders">IRS - Nº de Titulares</label>
                </span>
                <small v-if="errors.has('holders')" class="p-error" role="alert"
                  >IRS - Nº de Titulares</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-6">
                <span class="p-float-label">
                  <InputMask
                    id="irsDependents"
                    name="irsDependents"
                    mask="9"
                    v-model="userInfo.irsDependents"
                    v-bind:class="[
                      { 'p-error': errors.has('irsDependents') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="irsDependents">IRS - Nº de dependentes</label>
                </span>
                <small
                  v-if="errors.has('irsDependents')"
                  class="p-error"
                  role="alert"
                  >IRS - Nº de dependentes</small
                >
              </div>

              <div class="p-mt-3 p-field p-col-12 p-md-12">
                <span class="p-float-label">
                  <InputText
                    id="iban"
                    name="iban"
                    v-model="userInfo.iban"
                    v-bind:class="[
                      { 'p-error': errors.has('iban') },
                      'form-control',
                    ]"
                    :disabled="!inEditing"
                    v-validate="'required'"
                  />
                  <label for="iban">IBAN</label>
                </span>
                <small v-if="errors.has('iban')" class="p-error" role="alert"
                  >IBAN é obrigatório</small
                >
              </div>
            </div>
          </div>

          <div class="p-field p-col-12 p-md-7">
            <ProfileLiteraryAbilities
              v-bind:userLiteraryAbilities="userLiteraryAbilities"
              v-bind:inEditing="inEditing"
              v-bind:removed="removed.literaryAbilities"
            />
            <Divider />
            <ProfileAdditionalTraining
              v-bind:userAdditionalTraining="userAdditionalTraining"
              v-bind:inEditing="inEditing"
              v-bind:removed="removed.additionalTraining"
            />
            <Divider />
            <ProfileProfessionalExperience
              v-bind:userProfessionalExperience="userProfessionalExperience"
              v-bind:inEditing="inEditing"
              v-bind:removed="removed.professionalExperience"
            />
            <Divider />
            <ProfileDocs
              v-bind:userprofileDocs="userprofileDocs"
              v-bind:inEditing="inEditing"
              v-bind:hasCar="this.userInfo.hasCar"
            />
          </div>
          <div class="p-field p-col-12 p-md-12" v-if="userId">
            <small>Última Actualiação: {{ userInfo.updated }}</small>
          </div>
        </div>
        <Button
          v-if="inEditing"
          label="Gravar"
          icon="pi pi-save"
          class="p-button-success"
          @click="save"
        />
        <Button
          v-if="inEditing"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger p-ml-1"
          @click="cancel"
        />
      </form>
    </div>
  </div>
</template>

<script>
import ProfileService from "@/services/profile.service";
import VacationsService from "@/services/vacations.service";
import { getOnlyDate, isDateBeforeToday } from "../helpers/helpers";
import ProfileLiteraryAbilities from "@/components/profile/ProfileLiteraryAbilities";
import ProfileAdditionalTraining from "@/components/profile/ProfileAdditionalTraining";
import ProfileProfessionalExperience from "@/components/profile/ProfileProfessionalExperience";
import ProfileDocs from "@/components/profile/ProfileDocs";
export default {
  name: "Profile",
  props: ["userId"],
  components: {
    ProfileLiteraryAbilities,
    ProfileAdditionalTraining,
    ProfileProfessionalExperience,
    ProfileDocs,
  },
  data() {
    return {
      loading: false,
      inEditing: false,
      namaritalStatusList: [
        { status: "Solteiro(a)" },
        { status: "Casado(a)" },
        { status: "Divorciado(a)" },
        { status: "Viúvo(a)" },
      ],
      userInfo: {},
      userInfoOri: {},
      userLiteraryAbilities: [],
      userAdditionalTraining: [],
      userProfessionalExperience: [],
      thatApprovesList: [],
      userprofileDocs: {
        citizenCard: { id: null, name: null, url: null },
        cv: { id: null, name: null, url: null },
        qualificationsCertificate: { id: null, name: null, url: null },
        carDeclaration: { id: null, name: null, url: null },
      },
      removed: {
        literaryAbilities: [],
        additionalTraining: [],
        professionalExperience: [],
      },
    };
  },
  computed: {
    currentUser() {
      if (this.$store.state.auth.loggedIn) {
        return this.$store.state.auth.user;
      }
      return null;
    },
    currentUserId() {
      if (this.userId && this.can("seeEmployeeFiles")) {
        return parseInt(this.userId);
      }
      return this.currentUser ? this.currentUser.id : null;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
  async created() {
    this.$validator.pause();
    this.thatApprovesList = await VacationsService.thatApproves();
    this.getUserAllInfo();
  },
  methods: {
    getUserAllInfo() {
      return ProfileService.getUserProfile(this.currentUserId).then(
        (response) => {
          this.removed.literaryAbilities = [];
          this.removed.additionalTraining = [];
          this.removed.professionalExperience = [];
          this.userLiteraryAbilities = response.literaryAbilities;
          this.userAdditionalTraining = response.additionalTraining;
          this.userProfessionalExperience = response.professionalExperience;
          this.userprofileDocs = response.documents;
          this.userInfoOri = { ...response };
          this.$emit("userInfoLoaded", this.userInfoOri);
          return (this.userInfo = response);
        }
      );
    },
    save() {
      this.$validator.resume();
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.$validator.pause();
        this.$validator.reset();

        let formData = new FormData();
        formData.append(
          "name",
          this.userInfo.name != undefined ? this.userInfo.name : ""
        );

        if (this.userInfo.birthDate != undefined) {
          if (this.userInfo.birthDate instanceof Date) {
            formData.append("birthDate", getOnlyDate(this.userInfo.birthDate));
          } else {
            formData.append("birthDate", this.userInfo.birthDate);
          }
        } else {
          formData.append("birthDate", "");
        }
        formData.append(
          "namaritalStatus",
          this.userInfo.namaritalStatus != undefined
            ? this.userInfo.namaritalStatus
            : ""
        );
        formData.append(
          "address",
          this.userInfo.address != undefined ? this.userInfo.address : ""
        );
        formData.append(
          "zipCode",
          this.userInfo.zipCode != undefined ? this.userInfo.zipCode : ""
        );
        formData.append(
          "local",
          this.userInfo.local != undefined ? this.userInfo.local : ""
        );
        formData.append(
          "telephone",
          this.userInfo.telephone != undefined ? this.userInfo.telephone : ""
        );
        formData.append(
          "personalEmail",
          this.userInfo.personalEmail != undefined
            ? this.userInfo.personalEmail
            : ""
        );
        formData.append(
          "citizenCardNum",
          this.userInfo.citizenCardNum != undefined
            ? this.userInfo.citizenCardNum
            : ""
        );

        if (this.userInfo.citizenCardDate != undefined) {
          if (this.userInfo.citizenCardDate instanceof Date) {
            formData.append(
              "citizenCardDate",
              getOnlyDate(this.userInfo.citizenCardDate)
            );
          } else {
            formData.append("citizenCardDate", this.userInfo.citizenCardDate);
          }
        } else {
          formData.append("citizenCardDate", "");
        }
        formData.append(
          "nif",
          this.userInfo.nif != undefined ? this.userInfo.nif : ""
        );
        formData.append(
          "niss",
          this.userInfo.niss != undefined ? this.userInfo.niss : ""
        );
        formData.append(
          "holders",
          this.userInfo.holders != undefined ? this.userInfo.holders : ""
        );
        formData.append(
          "irsDependents",
          this.userInfo.irsDependents != undefined
            ? this.userInfo.irsDependents
            : ""
        );
        formData.append(
          "iban",
          this.userInfo.iban != undefined ? this.userInfo.iban : ""
        );

        //ONLY UPDATE BY ACL
        if (this.can("editEmployeeFile")) {
          formData.append(
            "vacations1StYear",
            this.userInfo.vacations1StYear != undefined
              ? this.userInfo.vacations1StYear
              : 0
          );
          formData.append(
            "email",
            this.userInfo.email != undefined ? this.userInfo.email : ""
          );
          formData.append(
            "vacationsApproveTo",
            this.userInfo.vacationsApproveTo != undefined
              ? this.userInfo.vacationsApproveTo
              : ""
          );
          formData.append(
            "department",
            this.userInfo.department != undefined
              ? this.userInfo.department
              : ""
          );
          formData.append(
            "area",
            this.userInfo.area != undefined ? this.userInfo.area : ""
          );
          formData.append(
            "office",
            this.userInfo.office != undefined ? this.userInfo.office : ""
          );
          if (this.userInfo.startDate != undefined) {
            if (this.userInfo.startDate instanceof Date) {
              formData.append(
                "startDate",
                getOnlyDate(this.userInfo.startDate)
              );
            } else {
              formData.append("startDate", this.userInfo.startDate);
            }
          }
          if (this.userInfo.endContract != undefined) {
            if (this.userInfo.endContract instanceof Date) {
              formData.append(
                "endContract",
                getOnlyDate(this.userInfo.endContract)
              );
            } else {
              formData.append("endContract", this.userInfo.endContract);
            }
          }

          if (this.userInfo.exitDate != undefined) {
            if (this.userInfo.exitDate instanceof Date) {
              formData.append("exitDate", getOnlyDate(this.userInfo.exitDate));
            } else {
              formData.append("exitDate", this.userInfo.exitDate);
            }
          }
          formData.append(
            "hasCar",
            this.userInfo.hasCar != undefined && this.userInfo.hasCar == true
              ? 1
              : 0
          );
          formData.append(
            "inactive",
            this.userInfo.active != undefined && this.userInfo.active == true
              ? 0
              : 1
          );
        }

        this.userLiteraryAbilities.forEach((element, index) => {
          formData.append(`literaryAbilities[${index}][id]`, element.id);
          formData.append(
            `literaryAbilities[${index}][course]`,
            element.course
          );
          formData.append(
            `literaryAbilities[${index}][duration]`,
            element.duration
          );
          formData.append(
            `literaryAbilities[${index}][educationLevel]`,
            element.educationLevel
          );
          formData.append(
            `literaryAbilities[${index}][qualificationsLevel]`,
            element.qualificationsLevel
          );
          formData.append(
            `literaryAbilities[${index}][entity]`,
            element.entity
          );
          formData.append(`literaryAbilities[${index}][year]`, element.year);
          if (element.edited != undefined) {
            formData.append(
              `literaryAbilities[${index}][edited]`,
              element.edited
            );
          }
          if (element.new != undefined) {
            formData.append(`literaryAbilities[${index}][new]`, element.new);
          }
          if (element.file != undefined) {
            formData.append(
              `literaryAbilities[${index}][file_${element.id}]`,
              element.file
            );
          }
        });

        this.userAdditionalTraining.forEach((element, index) => {
          formData.append(`additionalTraining[${index}][id]`, element.id);
          formData.append(
            `additionalTraining[${index}][course]`,
            element.course
          );
          formData.append(
            `additionalTraining[${index}][duration]`,
            element.duration
          );
          formData.append(
            `additionalTraining[${index}][entity]`,
            element.entity
          );
          formData.append(`additionalTraining[${index}][year]`, element.year);
          if (element.edited != undefined) {
            formData.append(
              `additionalTraining[${index}][edited]`,
              element.edited
            );
          }
          if (element.new != undefined) {
            formData.append(`additionalTraining[${index}][new]`, element.new);
          }
          if (element.file != undefined) {
            formData.append(
              `additionalTraining[${index}][file_${element.id}]`,
              element.file
            );
          }
        });

        this.userProfessionalExperience.forEach((element, index) => {
          formData.append(`professionalExperience[${index}][id]`, element.id);
          formData.append(
            `professionalExperience[${index}][period]`,
            element.period
          );
          formData.append(
            `professionalExperience[${index}][entity]`,
            element.entity
          );
          formData.append(
            `professionalExperience[${index}][activity]`,
            element.activity
          );
          if (element.edited != undefined) {
            formData.append(
              `professionalExperience[${index}][edited]`,
              element.edited
            );
          }
          if (element.new != undefined) {
            formData.append(
              `professionalExperience[${index}][new]`,
              element.new
            );
          }
        });

        this.removed.literaryAbilities.forEach((element, index) => {
          formData.append(`removed[literaryAbilities][${index}]`, element.id);
        });
        this.removed.additionalTraining.forEach((element, index) => {
          formData.append(`removed[additionalTraining][${index}]`, element.id);
        });
        this.removed.professionalExperience.forEach((element, index) => {
          formData.append(
            `removed[professionalExperience][${index}]`,
            element.id
          );
        });

        if (
          this.userprofileDocs.citizenCard != null &&
          this.userprofileDocs.citizenCard.file != undefined &&
          this.userprofileDocs.citizenCard.file != null
        ) {
          formData.append(
            `documents[citizenCard][citizenCardFile]`,
            this.userprofileDocs.citizenCard.file
          );
        }
        if (
          this.userprofileDocs.cv != null &&
          this.userprofileDocs.cv.file != undefined &&
          this.userprofileDocs.cv.file != null
        ) {
          formData.append(
            `documents[cv][cvFile]`,
            this.userprofileDocs.cv.file
          );
        }
        if (
          this.userprofileDocs.qualificationsCertificate != null &&
          this.userprofileDocs.qualificationsCertificate.file != undefined &&
          this.userprofileDocs.qualificationsCertificate.file != null
        ) {
          formData.append(
            `documents[qualificationsCertificate][qualificationCertificateFile]`,
            this.userprofileDocs.qualificationsCertificate.file
          );
        }
        if (
          this.userprofileDocs.carDeclaration != null &&
          this.userprofileDocs.carDeclaration.file != undefined &&
          this.userprofileDocs.carDeclaration.file != null
        ) {
          formData.append(
            `documents[carDeclaration][carDeclarationFile]`,
            this.userprofileDocs.carDeclaration.file
          );
        }

        ProfileService.updateUserProfile(this.currentUserId, formData).then(
          (response) => {
            if (!response) {
              return this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Ocorreu um erro ao gravar",
                life: 3000,
              });
            }
            this.inEditing = false;
            this.getUserAllInfo();
            return this.$toast.add({
              severity: "success",
              summary: "Perfil Alterado",
              detail: "Perfil alterado com sucesso",
              life: 3000,
            });
          }
        );
      });
    },
    cancel() {
      this.inEditing = false;
      return this.getUserAllInfo();
    },
    validateCCDate(date) {
      if (!date) {
        return true;
      }
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      if (isDateBeforeToday(getOnlyDate(date))) {
        return false;
      }
      return true;
    },
  },
};
</script>
